import { render, staticRenderFns } from "./EModalTurmaFranquia.vue?vue&type=template&id=87c45a3a&scoped=true"
import script from "./EModalTurmaFranquia.vue?vue&type=script&lang=js"
export * from "./EModalTurmaFranquia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c45a3a",
  null
  
)

export default component.exports